import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

export const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    padding: "24px",
  },
});

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 500,
  color: theme.palette.text.primary,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 0,
  marginBottom: "16px",
  "& .MuiIconButton-root": {
    color: theme.palette.text.primary,
    fontSize: "24px",
  },
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "16px",
  marginBottom: "16px",
}));
export const StyledDialogContent = styled(DialogContent)({
  padding: "24px 0",
});

export const StyledDialogActions = styled(DialogActions)({
  justifyContent: "flex-end",
  padding: 0,
  marginTop: "16px",
});
